import axios from 'axios';

export function checkoutOrderSettings(data) {
  if (!data?.id || !data?.keyId || !/^[a-f\d]{24}$/i.test(data?.paymentIntentId || '') || !Number.isInteger(data?.amount) || data.amount < 100) {
    throw new Error('Unable to start payment: incomplete payment settings. Please try again.');
  }
  return { key: data.keyId, order_id: data.id, amount: data.amount, currency: data.currency || 'INR' };
}

export async function completeOnlineOrder({ apiUrl, headers, payment, checkout, wait = ms => new Promise(resolve => setTimeout(resolve, ms)) }) {
  const verified = await axios.post(`${apiUrl}/razorpay/verify`, {
    order_id: checkout.id,
    payment_id: payment.razorpay_payment_id,
    signature: payment.razorpay_signature,
  }, { headers });
  if (!verified.data?.success) throw new Error('Payment verification is pending. Please do not pay again.');
  // Reuse the server's idempotent finalizer, also used by the customer app.
  for (let attempt = 0; attempt < 30; attempt++) {
    const result = await axios.post(`${apiUrl}/order/finalize-payment/${checkout.paymentIntentId}`, {}, { headers });
    if (result.status === 202 || result.data?.pending) {
      await wait(2000);
      continue;
    }
    if (result.data?.error || !result.data?.order?._id) throw new Error(result.data?.message || 'Order confirmation is pending. Please do not pay again.');
    return result;
  }
  throw new Error('Payment received. Your order is still being confirmed. Check My Orders before trying again.');
}
